"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgUser(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.957 0a6.895 6.895 0 012.04 13.48c4.485.901 7.918 4.697 7.918 9.073v.681a.766.766 0 01-.766.766H2.766A.766.766 0 012 23.234v-.681c0-4.376 3.433-8.172 7.917-9.074A6.895 6.895 0 0111.957 0zm0 14.809c-4.613 0-8.425 3.591-8.425 7.744v-.085h16.85l-.003-.15c-.137-3.974-3.752-7.376-8.161-7.506zm0-13.277a5.363 5.363 0 000 10.723 5.363 5.363 0 000-10.723z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgUser;
exports.default = _default;